module.exports = __webpack_public_path__ + "static/media/GalleryImage15.719ba1e5.jpg";